import { graphql, useStaticQuery } from 'gatsby';

export interface Taxonomy {
    system: {
        codename: string;
        name: string;
    };
    terms: {
        codename: string;
        name: string;
    }[];
}

export interface TaxonomyNode {
    node: Taxonomy;
}

interface TaxonomyQuery {
    allKontentTaxonomy: {
        edges: TaxonomyNode[];
    };
}

export const useTaxonomy = (): TaxonomyNode[] => {
    const taxonomy: TaxonomyQuery = useStaticQuery(graphql`
        {
            allKontentTaxonomy {
                edges {
                    node {
                        system {
                            codename
                            name
                        }
                        terms {
                            codename
                            name
                        }
                    }
                }
            }
        }
    `);

    return taxonomy.allKontentTaxonomy.edges;
};
